"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _createMixin = _interopRequireDefault(require("@vfuk/core-styles/dist/utils/createMixin"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var loadingSpinnerTheme = function loadingSpinnerTheme(voxiTheme) {
  var svg = /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "25 25 50 50"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "50",
    cy: "50",
    r: "20"
  }));

  return {
    appearance: {
      primary: {
        color: voxiTheme.color.monochrome6["default"],
        inverse: {
          color: voxiTheme.color.monochrome1["default"]
        }
      },
      secondary: {
        color: voxiTheme.color.primary1["default"],
        inverse: {
          color: voxiTheme.color.primary1["default"]
        }
      }
    },
    svg: svg,
    size: {
      1: {
        width: 16,
        height: 16
      },
      2: {
        width: 24,
        height: 24
      },
      3: {
        width: 32,
        height: 32
      },
      4: {
        width: 40,
        height: 40
      },
      5: {
        width: 48,
        height: 48
      }
    },
    animationStyle: (0, _createMixin["default"])(function (theme, width, height, strokeColor) {
      return (0, _styledComponents.css)(["@supports (display:grid){display:inline-block;}display:none;width:", "px;height:", "px;@keyframes rotate{100%{transform:rotate(360deg);}}@keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0;}50%{stroke-dasharray:90,200;stroke-dashoffset:-35px;}100%{stroke-dashoffset:-125px;}}svg{width:100%;height:100%;transform-origin:center;animation:rotate 2s linear infinite;> circle{fill:none;stroke-width:5px;stroke-dasharray:1,200;stroke-dashoffset:0;stroke:", ";animation:dash 1.5s ease-in-out infinite;}}"], width, height, strokeColor);
    })
  };
};

var _default = loadingSpinnerTheme;
exports["default"] = _default;
//# sourceMappingURL=LoadingSpinner.voxi.theme.js.map